(ns teamoesterreich.user-mode.landing.app-panel.prevent-card
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.account-circle :refer [account-circle]]
    [reagent-material-ui.icons.home :refer [home]]
    [reagent.core :as r]

    [teamoesterreich.firebase.fb-questionnaire-helper :as fb-q-helper]
    [teamoesterreich.firebase.provider :as provider]
    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.ui-helper.stars :as stars]

    ))







(defn yes-prep []
  (let [
        fav-locationId (provider/get-fav-locationId)
        prep-enabled (deref (r/cursor store/app-state [:actual-user :prep-enabled]))
        loc (get-in @store/app-state [:locations])
        prep-loc (filter (fn [[k v]] (:preparation-enabled v)) (get-in @store/app-state [:locations]))

        fav-location (get loc fav-locationId)
        [first-location-id first-location] (first prep-loc)
        fav-locationId (if fav-location fav-locationId first-location-id)
        fav-location (or fav-location first-location)
        fav-location-name (or (:name fav-location) "Orte")
        ]
    [mui/paper {:class   "app-panel clickable"
                :style   {:textAlign "left" :cursor "hand"}
                :onClick #(a/set-page :prevent-overview)
                }
     [:div {:class "app-panel-img"}
      [:img {:src "/custom/img/vorsorgen_bunt.png" :alt "t-man"}]
      ]
     [:div {:class "app-panel-content"}
      [:div {:class "app-panel-title"}
       (txt/transl "Ich bereite mich vor")]
      [:div {:class "prevent-row"}
       [:div {:class "prevent-icon"}
        [account-circle {:fontSize "small"}]
        ]
       [:div {:class "prevent-name"}
        (txt/transl "Persönlich")]
       [:div {:class "prevent-stars"}
        (stars/five-stars (fb-q-helper/get-personal-stars))
        ]
       ]
      [:div {:class "prevent-row"}
       [:div {:class "prevent-icon"}
        [home {:fontSize "small"}]
        ]
       [:div {:class "prevent-name"}
        fav-location-name]
       [:div {:class "prevent-stars"}
        (stars/five-stars (fb-q-helper/get-location-stars fav-locationId))
        ]
       ]

      ]

     ]))

(defn no-prep []
  [mui/paper {:class   "app-panel clickable"
              :style   {:textAlign "left" :cursor "hand"}
              :onClick #(a/set-page :prevent-overview)
              }
   [:div {:class "app-panel-img"}
    [:img {:src "/custom/img/vorsorgen_bunt.png" :alt "t-man"}]
    ]
   [:div {:class "app-panel-content"}
    [:div {:class "app-panel-title"} (txt/transl "Ich will mich vorbereiten ....")]
    ]
   ])

(defn get-it []
  (let [!actual-user (r/cursor store/app-state [:actual-user])
        prep-enabled (deref (r/cursor store/app-state [:actual-user :prep-enabled]))]
    (if prep-enabled
      (yes-prep)
      (no-prep)
      )))
